import type { Node } from 'react-stately';
import type { Collection, Key, KeyboardDelegate } from '@react-types/shared';

type Options<T> = {
  collection: Collection<Node<T>>;
  disabledKeys: Set<Key>;
};

/**
 * Based upon react-aria ListKeyboardDelegate,
 * https://github.com/adobe/react-spectrum/blob/109ea066ed6d953abd2ee2cd7f8051823ae7cf52/packages/%40react-aria/selection/src/ListKeyboardDelegate.ts#L29
 */

export function stackKeyboardDelegate<T>({
  collection,
  disabledKeys,
}: Options<T>): KeyboardDelegate {
  return {
    getFirstKey() {
      let key = collection.getFirstKey();
      while (key != null) {
        const item = collection.getItem(key);
        if (item?.type === 'item' && !disabledKeys.has(key)) {
          return key;
        }
        key = collection.getKeyAfter(key);
      }
      return null;
    },
    getLastKey() {
      let key = collection.getLastKey();
      while (key != null) {
        const item = collection.getItem(key);
        if (item?.type === 'item' && !disabledKeys.has(key)) {
          return key;
        }
        key = collection.getKeyBefore(key);
      }
      return null;
    },
    getKeyAbove(key: Key) {
      let k = collection.getKeyBefore(key);
      while (k != null) {
        const item = collection.getItem(k);
        if (item?.type === 'item' && !disabledKeys.has(k)) {
          return k;
        }
        k = collection.getKeyBefore(k);
      }
      return null;
    },
    getKeyBelow(key: Key) {
      let k = collection.getKeyAfter(key);
      while (k != null) {
        const item = collection.getItem(k);
        if (item?.type === 'item' && !disabledKeys.has(k)) {
          return k;
        }
        k = collection.getKeyAfter(k);
      }
      return null;
    },
  };
}
